import { render, staticRenderFns } from "./AssignTableCircuits.vue?vue&type=template&id=ecb82fd2&scoped=true&"
import script from "./AssignTableCircuits.vue?vue&type=script&lang=ts&"
export * from "./AssignTableCircuits.vue?vue&type=script&lang=ts&"
import style0 from "./AssignTableCircuits.vue?vue&type=style&index=0&id=ecb82fd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecb82fd2",
  null
  
)

export default component.exports